import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Link } from "react-router-dom"

import { actions as appActions } from "../../modules/appModule"
import { COLOR, PATH } from "../../modules/constants"

import RegisterForm from "../../forms/RegisterForm"
import AnonPage, { Content } from "../../components/AnonPage"
import Navbar from "../../components/layout/DashboardNavbar"
import Footer from "../../components/Footer"

class Register extends Component {

  componentDidMount() {
    // console.log("componentDidMount() this.props: ", this.props)
    this.props.app.setPage(this.constructor.name)
  }

  render() {
    const { app, portrait, registerError, the350club, urlSource } = this.props

    // Lead-origin tracking: the 'origin' URL parameter (set by whoever linked here) is
    // recorded against the new user when they successfully submit the Register form
    const origin = new URLSearchParams(this.props.location.search).get('origin') || 'dummyOrigin'

    return (
      <React.Fragment>
        <Navbar backLink portrait={portrait} />

        <AnonPage>
          <Content scroll>
            <div className="form-page">
              <div className="form-cell">
                <div className="form-wrapper">
                  <p className="anon-short-title">Register for FREE 14 Day Trial</p>

                  <p className="anon-sub-title">
                    instant access - no payment details required
                  </p>

                  <p className="anon-details">
                    with detailed data on FTSE 100 companies and directors (subscribers get data for other UK listed companies)
                  </p>

                  <p className="anon-sub-title">
                    {the350club ? "Numerable has a user account system that is separate from that of 350 Club" : ""}
                  </p>

                  <RegisterForm
                    onSubmit={form => app.register({ ...form, origin })}
                    brandColor={COLOR.BRAND.STD}
                  />

                  <p className="error-message">
                    {registerError}
                  </p>

                  <p className="alternative-link" style={{ fontSize: "18px", fontWeight: "bold" }}>
                    <Link to={`/${PATH.LOGIN}`} style={{ color: COLOR.BRAND.STD }} >Already have an account? Log in</Link>
                  </p>
                </div>
              </div>
            </div>
          </Content>
        </AnonPage>

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    portrait: user.portrait,
    registerError: app.registerError,
    the350club: common.the350club,
    urlSource: common.urlSource,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)


